import React from 'react';
import { BeveledPanel } from './BeveledPanel';
import { getGreenLedMaterial, getCyanLedMaterial } from './equipmentMaterials';
import { getFabLedMaterial, FAB_TOOL_PALETTE } from './materials';
import type { EquipmentStatus } from '../../types';

export type StatusLightsProps = {
  width: number;
  height: number;
  depth: number;
  status?: EquipmentStatus;
  opacity?: number;
  position?: [number, number, number];
};

/** Small front status indicators — green ready, cyan busy, red offline. */
export const StatusLights: React.FC<StatusLightsProps> = ({
  width,
  height,
  depth,
  status = 'IDLE',
  opacity = 1,
  position = [0, 0, 0],
}) => {
  const ready = status === 'IDLE' || status === 'RUNNING';
  const busy = status === 'RUNNING';
  const fault = status === 'ERROR' || status === 'WARNING';

  return (
    <group name="StatusLights" position={position}>
      <BeveledPanel
        size={[width * 0.06, height * 0.014, depth * 0.012]}
        material={getGreenLedMaterial(ready ? 0.85 : 0.08, opacity)}
        position={[-width * 0.14, height * 0.26, depth * 0.02]}
      />
      <BeveledPanel
        size={[width * 0.06, height * 0.014, depth * 0.012]}
        material={getCyanLedMaterial(busy ? 0.9 : 0.06, opacity)}
        position={[0, height * 0.26, depth * 0.02]}
      />
      <BeveledPanel
        size={[width * 0.06, height * 0.014, depth * 0.012]}
        material={getFabLedMaterial(FAB_TOOL_PALETTE.ledRed, fault ? 0.85 : 0.06, opacity)}
        position={[width * 0.14, height * 0.26, depth * 0.02]}
      />
    </group>
  );
};

export default StatusLights;
